import React from 'react';
import Interweave from 'interweave';

/**
 * Renders a recommendation's `toolTipDesc` — an HTML string (e.g. an ordered
 * list with an embedded link) — as real markup for the Actionable-column
 * tooltip.
 *
 * The callers previously used `AutoLink`, which escaped everything that was not
 * a bare URL, so the HTML rendered as literal tags. `Interweave` is the same
 * renderer the sibling Description column already uses.
 */
export const getTooltipTitle = (row: Readonly<{ toolTipDesc?: string }>) => {
  return <Interweave content={row.toolTipDesc} />;
};
